export const background = {
  default: 'hsl(210, 28.571429%, 2.745098%)',
  subtle: 'hsl(204, 15.151515%, 6.470588%)',
}
export const surface = {
  default: 'hsl(204, 15.151515%, 6.470588%)',
  raised: 'hsl(206.666667, 11.688312%, 15.098039%)',
  sunken: 'hsl(210, 28.571429%, 2.745098%)',
}
export const text = {
  default: 'hsl(0, 0%, 96.078431%)',
  muted: 'hsl(200, 9.89011%, 82.156863%)',
  subtle: 'hsl(198, 4.385965%, 55.294118%)',
  inverse: 'hsl(210, 28.571429%, 2.745098%)',
  link: 'hsl(196.173913, 100%, 77.45098%)',
}
export const border = {
  default: 'hsl(204, 8.62069%, 22.745098%)',
  subtle: 'hsl(206.666667, 11.688312%, 15.098039%)',
  strong: 'hsl(198, 4.385965%, 55.294118%)',
}
export const action = {
  default: 'hsl(202.396313, 100%, 57.45098%)',
  hover: 'hsl(196.173913, 100%, 77.45098%)',
  subtle: 'hsl(222.545455, 100%, 10.784314%)',
}
export const success = {
  surface: 'hsl(120, 100%, 4.313725%)',
  text: 'hsl(115.081967, 35.260116%, 66.078431%)',
  border: 'hsl(121.333333, 100%, 17.647059%)',
  solid: 'hsl(118.181818, 47.826087%, 40.588235%)',
}
export const warning = {
  surface: 'hsl(6.153846, 100%, 7.647059%)',
  text: 'hsl(18, 74.626866%, 73.72549%)',
  border: 'hsl(19.849624, 95.683453%, 27.254902%)',
  solid: 'hsl(19.245283, 64.37247%, 51.568627%)',
}
export const danger = {
  surface: 'hsl(356.571429, 100%, 6.862745%)',
  text: 'hsl(358.636364, 67.692308%, 74.509804%)',
  border: 'hsl(347.288136, 90.769231%, 25.490196%)',
  solid: 'hsl(353.333333, 54.216867%, 51.176471%)',
}
export const info = {
  surface: 'hsl(228.461538, 86.666667%, 5.882353%)',
  text: 'hsl(218.181818, 35.106383%, 63.137255%)',
  border: 'hsl(219.74026, 60.629921%, 24.901961%)',
  solid: 'hsl(219.183673, 42.608696%, 45.098039%)',
}
